import React, {memo, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Badge} from "reactstrap";

const RenderStatusColumn = memo(({template}) => {


  const [badgeInformation, setBadgeInformation] = useState({
    'name': '',
    'color': '',
  })

  useEffect(() => {

    switch (template.render_status) {
      case 'PUBLISHED':
        setBadgeInformation({
          'name': 'Published',
          'color': 'success'
        })
        break;
      case 'DRAFT':
        setBadgeInformation({
          'name': 'Draft',
          'color': 'warning'
        })
        break;
      case 'EXPIRED':
        setBadgeInformation({
          'name': 'Expired',
          'color': 'danger'
        })
        break;
      case 'SCHEDULED':
        setBadgeInformation({
          'name': 'Scheduled',
          'color': 'info'
        })
        break;
      default:
        setBadgeInformation({
          'name': '',
          'color': '',
        })
    }
  }, [template.render_status])

  return (
    <td className={'text-center'}>
      <Badge className="badge-lg text-md" color={badgeInformation.color}>
        {badgeInformation.name}
      </Badge>
    </td>
  )
});

RenderStatusColumn.propTypes = {
  template: PropTypes.object.isRequired,
};

export default RenderStatusColumn;
